<template>
  <div class="activityType">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12"
            ><el-button
              size="small"
              icon="el-icon-plus"
              @click="add"
              v-access:add
              type="danger"
              >新增</el-button
            ></el-col
          >
          <el-col :span="12">
            <div class="search-box">
              <el-input
                class="toolBar-search"
                v-model="request.searchKey"
                placeholder="活动类型"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData(1)"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        :data="list"
        v-loading="loading"
        style="width: 100%"
        border
        :max-height="tableMaxHeight()"
      >
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="ActivityType" label="活动类型" />
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-access:modify
              type="text"
              size="mini"
              @click="deleted(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="request.pageSize"
          :currentPage="request.pageIndex"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
      <el-dialog :title="title" :visible.sync="dialogVisible" width="30%">
        <el-form
          :model="form"
          ref="form"
          :rules="rules"
          label-width="100px"
          label-position="right"
        >
          <el-form-item label="活动类型" prop="ActivityType">
            <el-input
              v-model="form.ActivityType"
              placeholder="请输入活动类型"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </BasePage>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";
export default {
  name: "activityType",
  data() {
    return {
      request: {
        pageIndex: 1,
        pageSize: 15,
        searchKey: "",
        ItemKey: "RC_VolunteerType",
      },
      list: [],
      total: 0,
      title: "",
      dialogVisible: false,
      loading: false,
      form: {},
      rules: {
        ActivityType: {
          required: true,
          max: 64,
          message: "活动类型不能为空且长度在64个字以内",
          trigger: "blur",
        },
      },
    };
  },
  components: {
    BasePage,
    OfPagination,
  },
  mounted() {
    const vm = this;
    vm.loadData(1);
  },
  methods: {
    deleted(row) {
      const vm = this;
      vm.$confirm("确定删除选中活动类型?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = { id: row.Id };
        api.DeletedActivityTypeById(param).then((res) => {
          if (res.data.Code === 0) {
            vm.$message({
              message: "删除成功",
              type: "success",
            });
            vm.loadData(1);
          }
        });
      });
    },
    onSubmit() {
      const vm = this;
      vm.$refs.form.validate((valid) => {
        if (valid) {
          const param = Object.assign({}, vm.form);
          param.ItemKey = "RC_VolunteerType";
          api.SaveActivityType(param).then((res) => {
            if (res.data.Code === 0) {
              vm.$message({
                message: "提交成功",
                type: "success",
              });
              vm.dialogVisible = false;
              vm.loadData(1);
            }
          });
        }
      });
    },
    add() {
      const vm = this;
      vm.form = {};
      vm.title = "新增活动类型";
      vm.dialogVisible = true;
    },
    edit(row) {
      const vm = this;
      vm.title = "编辑活动类型";
      vm.form = row;
      vm.dialogVisible = true;
    },
    loadData(pageIndex) {
      const vm = this;
      vm.loading = true;
      vm.request.pageIndex = pageIndex;
      api.GetActivityTypeList(vm.request).then((res) => {
        if (res.data.Code === 0) {
          vm.list = res.data.Data.rows;
          vm.total = res.data.Data.total;
          vm.loading = false;
        }
      });
    },
    handleCurrentChange(pageIndex) {
      const vm = this;
      if (vm.total > vm.request.pageSize) {
        vm.loadData(pageIndex);
      }
    },
    handleSizeChange(pageSize) {
      const vm = this;
      vm.request.pageSize = pageSize;
      vm.loadData(1);
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.activityType {
  .search-box {
    text-align: right;
    .toolBar-search {
      width: 300px;
      margin-right: 10px;
    }
  }
}
</style>